/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { SeparateEmail } from '../SeparateEmail'

type Props = {
  platform: Platform
}

export const SubscriptionCanceled = ({ platform }: Props) => (
  <SeparateEmail
    memberEmailType={EmailTemplateTypeEnum.MembershipCanceled}
    adminEmailType={EmailTemplateTypeEnum.MembershipCanceledAdmin}
    platformId={platform.id}
  />
)
